var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "top"
  }, [_vm._v("授权微脉输入法")]), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": "https://imagessl.lingtuo.cn/A-1ed71af7_20241111151509.png"
    }
  }), _c('p', {
    staticClass: "desc"
  }, [_vm._v(" 前往系统偏好设置"), _c('br'), _vm._v(" 安全性与隐私-隐私-辅助功能"), _c('br'), _vm._v(" 添加并打开 微脉输入法 ")])]);
}];
export { render, staticRenderFns };